import * as React from 'react';

const Pl16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#D80031", d: "M1 8h14v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3H1z" }));
Pl16.Size = 16;
Pl16.Title = "Pl";

export { Pl16 as default };
